var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-container"},[_c('mobileStatusBar',{attrs:{"title":"操作指引"}}),_c('div',{staticClass:"page-detail"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.czzy.name))]),_c('div',{staticClass:"detail"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.czzy.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }